import './loader.scss';

function Loader() {
  return <div className="loader" aria-label="Загрузка"></div>;
}

export default Loader;
